import { render, staticRenderFns } from "./LgpdSobreModal.vue?vue&type=template&id=46292d1e&scoped=true"
import script from "./LgpdSobreModal.vue?vue&type=script&lang=js"
export * from "./LgpdSobreModal.vue?vue&type=script&lang=js"
import style0 from "./LgpdSobreModal.vue?vue&type=style&index=0&id=46292d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46292d1e",
  null
  
)

export default component.exports